<template>
  <div class="content-body">
    <section class="flexbox-container">
      <div class="col-12 d-flex justify-content-center">
        <div class="col-md-4 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-body">
              <form class="form-horizontal" id="register-form" v-on:submit.prevent="register">
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="email" class="form-control" id="email" placeholder="Your Email" required v-model="email">
                  <div class="form-control-position">
                    <i class="ft-mail"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="first_name" placeholder="First Name" required v-model="first_name">
                  <div class="form-control-position">
                    <i class="ft-user"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="last_name" placeholder="Last Name" required v-model="last_name">
                  <div class="form-control-position">
                    <i class="ft-user"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="password" class="form-control" id="password" placeholder="Enter Password" required v-model="password">
                  <div class="form-control-position">
                    <i class="ft-lock"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="password" class="form-control" id="confirm_password" placeholder="Confirm Password" required v-model="confirm_password">
                  <div class="form-control-position">
                    <i class="ft-lock"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="cellphone" placeholder="Mobile Number" v-model="cellphone" disabled>
                  <div class="form-control-position">
                    <i class="ft-phone"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative">
                  <select class="form-control" id="company_id" placeholder="Company" required v-model="company_id">
                    <option value="">Select Company</option>
                    <option v-for="company in companies" v-bind:key="company.id" v-bind:value="company.id">{{company.name}}</option>
                  </select>
                </fieldset>

                <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                  <strong>Oh snap!</strong> {{errorMsg}}
                </div>

                <div class="form-group text-center">
                  <button type="submit" class="btn btn-block btn-glow btn-primary">Register</button>
                </div>

                <p class="card-subtitle text-muted my-1"><span>Already have an account ? <router-link to="/login" class="card-link">Log In</router-link></span></p>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'register',
  data: function () {
    return {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      confirm_password: '',
      cellphone: '',
      company_id: '',
      companies: [],
      errorMsg: '',
      errorMsg2: ''
    }
  },
  mounted: function () {
    var that = this

    this.cellphone = window.localStorage.getItem('mobile')

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'basic/companies',
      type: 'get',
      success: function (data) {
        data.data.forEach(function (company) {
          that.companies.push({
            id: company.id,
            name: company.name
          })
        })
      }
    })
  },
  methods: {
    register: function () {
      var that = this
      this.errorMsg = ''

      if (this.password !== this.confirm_password) {
        this.errorMsg = 'Confirmed password not the same as password'
      }

      if (this.company_id === '') {
        this.errorMsg = 'You need to select a company'
      }

      if (this.errorMsg === '') {
        var data = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          password: this.password,
          confirm_password: this.confirm_password,
          cellphone: this.cellphone,
          company_id: this.company_id,
          deviceId: window.localStorage.getItem('deviceId')
        }

        $.ajax({
          beforeSend: function (xhr) {
            $.showLoading()
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          complete: function () {
            $.hideLoading()
          },
          url: this.$config.apiUrl + 'basic/register',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            if (typeof data.success !== 'undefined' && data.success === true) {
              window.localStorage.setItem('user', JSON.stringify(data.data))
              window.localStorage.setItem('token', data.meta.token)
              that.$router.push('/')
            } else {
              that.showError(data.message)
            }
          },
          error: function (data) {
            that.showError(data.message)
          }
        })
      }
    }
  }
}
</script>
<template>
  <div class="content-body">
    <section class="flexbox-container">
      <div class="col-12 d-flex justify-content-center">
        <div class="col-md-4 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-body">
              <form class="form-horizontal" id="register-form" v-on:submit.prevent="register">
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="email" class="form-control" id="email" placeholder="Your Email" required v-model="email">
                  <div class="form-control-position">
                    <i class="ft-mail"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="first_name" placeholder="First Name" required v-model="first_name">
                  <div class="form-control-position">
                    <i class="ft-user"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="last_name" placeholder="Last Name" required v-model="last_name">
                  <div class="form-control-position">
                    <i class="ft-user"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="password" class="form-control" id="password" placeholder="Enter Password" required v-model="password">
                  <div class="form-control-position">
                    <i class="ft-lock"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="password" class="form-control" id="confirm_password" placeholder="Confirm Password" required v-model="confirm_password">
                  <div class="form-control-position">
                    <i class="ft-lock"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" class="form-control" id="cellphone" placeholder="Mobile Number" v-model="cellphone" disabled>
                  <div class="form-control-position">
                    <i class="ft-phone"></i>
                  </div>
                </fieldset>
                <fieldset class="form-group position-relative">
                  <select class="form-control" id="company_id" placeholder="Company" required v-model="company_id">
                    <option value="">Select Company</option>
                    <option v-for="company in companies" v-bind:key="company.id" v-bind:value="company.id">{{company.name}}</option>
                  </select>
                </fieldset>

                <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                  <strong>Oh snap!</strong> {{errorMsg}}
                </div>

                <div class="form-group text-center">
                  <button type="submit" class="btn btn-block btn-glow btn-primary">Register</button>
                </div>

                <p class="card-subtitle text-muted my-1"><span>Already have an account ? <router-link to="/login" class="card-link">Log In</router-link></span></p>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'register',
  data: function () {
    return {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      confirm_password: '',
      cellphone: '',
      company_id: '',
      companies: [],
      errorMsg: '',
      errorMsg2: ''
    }
  },
  mounted: function () {
    var that = this

    this.cellphone = window.localStorage.getItem('mobile')

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'basic/companies',
      type: 'get',
      success: function (data) {
        data.data.forEach(function (company) {
          that.companies.push({
            id: company.id,
            name: company.name
          })
        })
      }
    })
  },
  methods: {
    register: function () {
      var that = this
      this.errorMsg = ''

      if (this.password !== this.confirm_password) {
        this.errorMsg = 'Confirmed password not the same as password'
      }

      if (this.company_id === '') {
        this.errorMsg = 'You need to select a company'
      }

      if (this.errorMsg === '') {
        var data = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          password: this.password,
          confirm_password: this.confirm_password,
          cellphone: this.cellphone,
          company_id: this.company_id,
          deviceId: window.localStorage.getItem('deviceId')
        }

        $.ajax({
          beforeSend: function (xhr) {
            $.showLoading()
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          complete: function () {
            $.hideLoading()
          },
          url: this.$config.apiUrl + 'basic/register',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            if (typeof data.success !== 'undefined' && data.success === true) {
              window.localStorage.setItem('user', JSON.stringify(data.data))
              window.localStorage.setItem('token', data.meta.token)
              that.$router.push('/')
            } else {
              that.showError(data.message)
            }
          },
          error: function (data) {
            that.showError(data.message)
          }
        })
      }
    }
  }
}
</script>
